import { supabase } from '@/integrations/supabase/client';

export const fetchCleanerReviews = async (cleanerId: string) => {
  return await supabase.rpc('fetch_cleaner_reviews_with_metrics', {
    searched_cleaner_id: cleanerId,
  });
};
